import mutationsTypes from '@/vuex/auth/mutations-types.js'
const types = {
  ...mutationsTypes,
  PERFORM_LOGIN: 'PERFORM_LOGIN',
  PERFORM_LOGOUT: 'PERFORM_LOGOUT'
}

export default types
